import { render, staticRenderFns } from "./errorTip.vue?vue&type=template&id=3c52bf26&scoped=true"
import script from "./errorTip.vue?vue&type=script&lang=js"
export * from "./errorTip.vue?vue&type=script&lang=js"
import style1 from "./errorTip.vue?vue&type=style&index=1&id=3c52bf26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c52bf26",
  null
  
)

export default component.exports